import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {IntlModule} from "@sinequa/core/intl";

import {UtilsModule} from "@sinequa/components/utils";
import {BsSelectionModule} from "@sinequa/components/selection";
import {BsActionModule} from "@sinequa/components/action";
import { BsTooltipComponent } from "@sinequa/analytics/tooltip";

import {BsTimelineComponent} from "./timeline.component";
import {BsFacetTimelineComponent} from "./facet-timeline.component";
import { TimelineLegendComponent } from "./timeline-legend.component";
import { BsFacetDate } from "./facet-date";
import { BsAdvancedModule } from "@sinequa/components/advanced";
import { BsFacetModule } from "@sinequa/components/facet";
import { CollapseModule } from "@sinequa/components/collapse";

@NgModule({
    imports: [
        FormsModule, ReactiveFormsModule,
        CommonModule,
        IntlModule,

        UtilsModule,
        BsSelectionModule,
        BsActionModule,
        BsTooltipComponent,
        BsAdvancedModule,
        BsFacetModule,
        CollapseModule,
    ],
    declarations: [
        BsTimelineComponent,
        BsFacetTimelineComponent,
        TimelineLegendComponent,
        BsFacetDate
    ],
    exports: [
        BsTimelineComponent,
        BsFacetTimelineComponent,
        TimelineLegendComponent,
        BsFacetDate
    ]
})
export class BsTimelineModule {
}
